module.exports = __webpack_public_path__ + "img/video-empty-icon.7be13cb8.png";